import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatSnackBar, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
	encapsulation: ViewEncapsulation.None,
	selector: 'app-snack-bar',
	styleUrls: ['./snack-bar.component.scss'],
	templateUrl: './snack-bar.component.html',
})
export class SnackBarComponent {
	getInfoMessage = (type: string, info: string): string => {
		if (type === 'error' && (!info || info === '')) {
			return 'Desculpe, ocorreu um erro interno. Tente novamente mais tarde ou contate o suporte.';
		}

		return info;
	};

	// type: success, error, info
	constructor(
		@Inject(MAT_SNACK_BAR_DATA) public data: { info: ''; type: '' },
		private readonly _snack: MatSnackBar,
	) {}

	public closeSnack() {
		this._snack.dismiss();
	}
}
